"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NavigationSectionWrapper = _interopRequireDefault(require("./NavigationSectionWrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var NavigationSection = function NavigationSection(_ref) {
  var autoFocus = _ref.autoFocus,
    children = _ref.children,
    isSubsection = _ref.isSubsection,
    isVisible = _ref.isVisible,
    variant = _ref.variant,
    hasPadding = _ref.hasPadding;
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (isSubsection) {
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_NavigationSectionWrapper["default"], {
    autoFocus: autoFocus,
    variant: variant,
    tabIndex: isVisible ? 0 : -1,
    onKeyDown: handleOnKeyDown,
    hasPadding: hasPadding
  }, children);
};
NavigationSection.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  autoFocus: _propTypes["default"].bool,
  isSubsection: _propTypes["default"].bool,
  isVisible: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['menu', 'selectedMenu']),
  hasPadding: _propTypes["default"].bool
} : {};
NavigationSection.defaultProps = {
  autoFocus: false,
  isSubsection: false,
  isVisible: false,
  variant: 'menu'
};
var _default = exports["default"] = NavigationSection;